import * as React from 'react';

import type {FilterObject} from 'nutshell-core/types';

import {EntityListContainer} from '../../../email-marketing/entity-lists/entity-list-container';
import type {ReportURLParams} from '../../../reports/report-types';

import {formFieldFilterFunction} from '../form-field-filter-function';

import {FormRespondentsListProvider} from './form-respondents-list-provider';

type Props = {
    formId: string;
    defaultFields: string[];
    unfilteredCount: number;
    filters: FilterObject[];
    search: string;
    selectedPage: number;
    selectedSortField: string;
    selectedFields: string[];
    urlParams: ReportURLParams<'contacts'>;
    onParamChange: (arg1: any, arg2: boolean) => any;
    onRemoveAllFilters: () => void;
    customEmptyStateComponent: React.ReactNode;
};

export function FormRespondentsListContainer(props: Props) {
    const {formId, defaultFields, ...restProps} = props;

    return (
        <FormRespondentsListProvider>
            <EntityListContainer
                {...restProps}
                entityType='contacts'
                formId={formId}
                customEmptyStateComponent={props.customEmptyStateComponent}
                fieldFilterFunction={formFieldFilterFunction}
                unfilteredCount={props.unfilteredCount}
                unfilteredCountThreshold={0}
                parentEntityId={formId}
                scrollContainerSelector='#form-respondents-list'
                defaultFields={defaultFields}
                showEmailButton={true}
                hasPeopleListFooter={true}
            />
        </FormRespondentsListProvider>
    );
}
